import { atom } from "recoil";
import { CountedSavedSearches } from "../types/SavedSearchTypes";

export const CountedSavedSearchesAtom = atom<CountedSavedSearches[]>({
  key: "CountedSavedSearches",
  default: [],
});
